import { useState, useEffect, useRef, useMemo } from 'react';

// Локальный поисковый выпадающий список (без запроса на сервер) — печатаешь текст,
// список options фильтруется на месте. Для больших локальных справочников (статьи, сделки).
export default function Combobox({ value, onChange, options, placeholder, disabled, allowClear = true }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  const selected = options.find(o => String(o.value) === String(value));

  useEffect(() => {
    const onClickOutside = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  useEffect(() => { if (!open) setQuery(''); }, [open]);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter(o => o.label.toLowerCase().includes(q));
  }, [options, query]);

  const pick = (opt) => { onChange(opt ? opt.value : ''); setOpen(false); setQuery(''); };

  return (
    <div className="search-select" ref={boxRef}>
      <input
        value={open ? query : (selected?.label || '')}
        onChange={e => { setQuery(e.target.value); setOpen(true); }}
        onFocus={() => { setOpen(true); setQuery(''); }}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
      />
      {open && (
        <div className="search-select-list">
          {allowClear && <div className="search-select-item text-muted" onClick={() => pick(null)}>— Не выбрано —</div>}
          {filtered.length === 0 && <div className="search-select-empty">Ничего не найдено</div>}
          {filtered.map(opt => (
            <div key={opt.value} className="search-select-item" onClick={() => pick(opt)}>{opt.label}</div>
          ))}
        </div>
      )}
    </div>
  );
}
